<template>
  <th>
    <div class="py-4 border-b border-gray-300">
      <div class="text-lg font-bold">
        <span class="relative">
        {{ dayName }}
          <span
            v-if="order"
            :class="{
              'w-3 h-3 rounded-full absolute top-1 -right-4': true,
              'bg-green-500': order.submitted,
              'bg-yellow-500': !order.submitted && order.editable,
              'bg-red-500': !order.submitted && !order.editable,
            }">
          </span>
        </span>
      </div>
      <span class="font-normal">
        {{ formattedDay }}
      </span>
    </div>
  </th>
</template>

<script>
import format from 'date-fns/format'
import deLocale from 'date-fns/locale/de'

export default {
  name: 'DayCell',
  props: {
    day: {
      type: Date,
      required: true
    },
    order: {
      type: Object,
      default: () => null
    }
  },

  computed: {
    dayName() {
      return format(this.day, 'EEEEEE',  { locale: deLocale })
    },

    formattedDay() {
      return format(this.day, 'dd.MM.', {
        locale: deLocale
      })
    }
  }
}
</script>
